/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
  Select,
  Space,
  DatePicker,
  Button,
  Tag,
  Modal,
  Row,
  Col,
  message,
  Form,
  Popover,
  Tabs,
  Typography,
  Input,
  Drawer,
  Descriptions,
  Tooltip,
  TreeSelect,
  Checkbox
} from 'antd';
import { updatePlanModal, updateNavigationTourGuide } from 'store/user';
import {
  CaretDownOutlined,
  DownOutlined,
  EyeFilled,
  CloseOutlined,
  InfoCircleOutlined,
  SearchOutlined,
  CheckOutlined
} from '@ant-design/icons';
import Joyride, { STATUS, ACTIONS, EVENTS } from 'react-joyride';
import dayjs from 'dayjs';
import EbzButton from 'components/EbzButton';
import EbzFilterGroup from 'components/EbzFilterGroup';
import reportsAPI from 'services/reports';
import EbzTable from 'components/EbzTable';
import Alert from 'components/Alert';
import { customReportStatus, customReportTransactionsStatus } from 'constants';
import {
  CUSTOM_REPORT_STATUS,
  CUSTOM_REPORT_TRANSACTION_STATUS,
  CUSTOM_REPORT_TRANSFER_STATUS,
  CUSTOM_REPORT_INSTACOLLECT_TRANSACTION_STATUS
} from 'constants/status';
import {
  CloseIcon,
  SuccessIcon,
  FailedIcon,
  InProgressIcon,
  DownloadIcon,
  CopyIcon
} from 'utils/icons';
import merchantAPI from 'services/merchants';
import customReportTableBlur from 'assets/images/custom_report_table.webp';
import joyrideCustomTooltip from 'components/JoyrideComponent/JoyrideTooltip';
import trackingService from 'services/trackingService';
import EVENT_NAME from 'utils/const';
import {
  BITLA_ID,
  GTV_TYPE,
  PARTENR_PRODUCT_LIST,
  STATES,
  TESTING_ID,
  TOUR_CUSTOM_REPORT_CONTENT
} from './const';

const customParseFormat = require('dayjs/plugin/customParseFormat');

dayjs.extend(customParseFormat);

const { RangePicker } = DatePicker;
// const { Option } = Select;

const CustomScrollWrapper = styled.div`
  &::-webkit-scrollbar-track {
    background-color: #dedede;
  }

  &::-webkit-scrollbar {
    width: 4px;
    background-color: #878787;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #878787;
  }
`;

const EbzPopover = styled(Popover)`
  //popover
  .ant-popover-arrow {
    display: none !important;
  }

  .ant-popover-content {
    position: relative;
    top: -10px;
  }
`;

const SelectWrapper = styled(Select)`
  .ant-select-selection-overflow {
    flex-wrap: nowrap;
    overflow: auto;
  }

  .ant-select-selection-overflow::-webkit-scrollbar {
    display: none;
  }

  .ant-select-selection-overflow::-moz-scrollbar {
    display: none;
  }
`;

const MenuTabBarWrapper = styled.div`
  && {
    font-size: 18px;

    .ant-tabs-tab {
      padding: 12px 10px;
    }

    .ant-tabs-nav::before {
      border-bottom: 2px solid rgba(5, 5, 5, 0.06);
    }
  }
`;

const renderTabBarMenu = (props, DefaultTabBar) => {
  return (
    <MenuTabBarWrapper>
      <DefaultTabBar {...props} />
    </MenuTabBarWrapper>
  );
};

const TreeSelectWrapper = styled(TreeSelect)`
  .ant-select-selection-overflow {
    flex-wrap: nowrap;
    overflow: auto;
  }

  .ant-select-selection-overflow::-webkit-scrollbar {
    display: none;
  }

  .ant-select-selection-overflow::-moz-scrollbar {
    display: none;
  }

  .ant-tree-select-dropdown .ant-select-tree .ant-select-tree-treenode {
    width: 100% !important;
  }
`;

function EbzTreeSelect({ merchant, value, onChange }) {
  const [selectedValues, setSelectedValues] = useState([]);
  const [merchantData, setMerchantData] = useState([]);
  const [filteredMerchantData, setFilteredMerchantData] = useState(null);
  const [allIds, setAllIds] = useState([]);

  useEffect(() => {
    if (merchant.length > 0) {
      const y = merchant.map((e) => {
        return {
          title: `${e.label} - ${e.value} - ${e.email}`,
          value: e.value,
          id: e.value
        };
      });

      setMerchantData(y);
      setAllIds(y);
    }
  }, [merchant]);

  const tagRender = (props) => {
    // eslint-disable-next-line react/prop-types
    const { label, closable, onClose } = props;

    return (
      <Tag
        color="#FFFFFF"
        closable={closable}
        onClose={onClose}
        style={{
          color: '#091B49',
          border: '1px solid #091B49',
          cursor: 'default'
        }}
        closeIcon={<CloseOutlined style={{ color: '#091B49' }} />}
      >
        {label}
      </Tag>
    );
  };

  const handleSearch = (e) => {
    const v = e.target.value?.toLowerCase();

    if (v && v.length > 0) {
      const hasSearchTerm = (n) => n.toLowerCase().indexOf(v) !== -1;
      const filterData = (arr) => arr?.filter((n) => hasSearchTerm(n.title));
      const filteredData = filterData(merchantData).map((n) => {
        return {
          ...n,
          children: filterData(n.children)
        };
      });
      setFilteredMerchantData(filteredData);
    } else {
      setFilteredMerchantData(merchantData);
    }
  };

  return (
    <TreeSelectWrapper
      allowClear
      placeholder="Please Select Merchant"
      treeCheckable
      showCheckedStrategy={TreeSelect.SHOW_CHILD}
      dropdownStyle={{ maxHeight: '300px' }}
      onChange={(ids) => {
        onChange(ids);
        setSelectedValues(ids);
      }}
      value={value || selectedValues}
      labelInValue
      tagRender={tagRender}
      showSearch={false}
      suffixIcon={<CaretDownOutlined style={{ fontSize: '15px', color: '#2A2A2A' }} />}
      showArrow
      dropdownRender={(menu) => (
        <>
          <div style={{ padding: '10 10px' }}>
            <Input
              prefix={<SearchOutlined />}
              placeholder="Please Search Merchant"
              onChange={handleSearch}
              style={{
                width: '100%'
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
            />
          </div>
          {menu}
        </>
      )}
      treeData={[
        {
          title:
            selectedValues.length > 0 ? (
              <span
                onClick={() => {
                  onChange([]);
                  setSelectedValues([]);
                }}
                style={{
                  display: 'inline-block',
                  color: 'var(--color-primary)',
                  cursor: 'pointer'
                }}
              >
                Unselect all
              </span>
            ) : (
              <span
                onClick={() => {
                  onChange(allIds);
                  setSelectedValues(allIds);
                }}
                style={{
                  display: 'inline-block',
                  color: 'var(--color-primary)',
                  cursor: 'pointer'
                }}
              >
                Select all
              </span>
            ),
          value: 'NA',
          disableCheckbox: true,
          disabled: true
        },
        ...(filteredMerchantData === null ? merchantData : filteredMerchantData)
      ]}
    />
  );
}

function EbzTreeSelect1({ data, placeHolder, value, onChange, shouldSelectAll }) {
  const [selectedValues, setSelectedValues] = useState([]);
  const [option, setOption] = useState([]);
  const [filteredOption, setFilteredOption] = useState(null);
  const [allIds, setAllIds] = useState([]);

  useEffect(() => {
    if (data.length > 0) {
      const y = data.map((e) => {
        return {
          title: `${e.label}`,
          value: e.value
        };
      });
      setAllIds(y);
      if (shouldSelectAll) setSelectedValues(y);
      setOption(y);
    }
  }, [data]);

  const tagRender = (props) => {
    // eslint-disable-next-line react/prop-types
    const { label, closable, onClose } = props;

    return (
      <Tag
        color="#FFFFFF"
        closable={closable}
        onClose={onClose}
        style={{
          color: '#091B49',
          border: '1px solid #091B49',
          cursor: 'default'
        }}
        closeIcon={<CloseOutlined style={{ color: '#091B49' }} />}
      >
        {label}
      </Tag>
    );
  };

  const handleSearch = (e) => {
    const v = e.target.value?.toLowerCase();

    if (v && v.length > 0) {
      const hasSearchTerm = (n) => n.toLowerCase().indexOf(v) !== -1;
      const filterData = (arr) => arr?.filter((n) => hasSearchTerm(n.title));
      const filteredData = filterData(option).map((n) => {
        return {
          ...n,
          children: filterData(n.children)
        };
      });
      setFilteredOption(filteredData);
    } else {
      setFilteredOption(option);
    }
  };

  return (
    <TreeSelectWrapper
      allowClear
      placeholder={placeHolder}
      treeCheckable
      showCheckedStrategy={TreeSelect.SHOW_CHILD}
      dropdownStyle={{ maxHeight: '300px' }}
      onChange={(ids) => {
        onChange(ids);
        setSelectedValues(ids);
      }}
      value={value || selectedValues}
      labelInValue
      tagRender={tagRender}
      showSearch={false}
      suffixIcon={<CaretDownOutlined style={{ fontSize: '15px', color: '#2A2A2A' }} />}
      showArrow
      dropdownRender={(menu) => (
        <>
          <div style={{ padding: '10px 10px' }}>
            <Input
              prefix={<SearchOutlined />}
              placeholder="Please Search Product"
              onChange={handleSearch}
              style={{
                width: '100%'
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
            />
          </div>
          {menu}
        </>
      )}
      treeData={[
        {
          title:
            selectedValues.length > 0 ? (
              <span
                onClick={() => {
                  onChange([]);
                  setSelectedValues([]);
                }}
                style={{
                  display: 'inline-block',
                  color: 'var(--color-primary)',
                  cursor: 'pointer'
                }}
              >
                Unselect all
              </span>
            ) : (
              <span
                onClick={() => {
                  onChange(allIds);
                  setSelectedValues(allIds);
                }}
                style={{
                  display: 'inline-block',
                  color: 'var(--color-primary)',
                  cursor: 'pointer'
                }}
              >
                Select all
              </span>
            ),
          value: 'NA',
          disableCheckbox: true,
          disabled: true
        },
        ...(filteredOption === null ? option : filteredOption)
      ]}
    />
  );
}

function CustomReportsListPage() {
  // page state
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [hasData, setHasData] = useState(false);
  const [customReportType, setCustomReportType] = useState(null);
  const [merchant, setMerchant] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentView, setCurrentView] = useState(null);
  const [viewMoreModal, setViewMoreModal] = useState(false);
  const [dates, setDates] = useState(null);
  const [pendingCount, setpendingCount] = useState(0);

  const [selectedItems, setSelectedItems] = useState([]);

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: false,
      total: 0
    }
  });
  const [filtersObj, setFiltersObj] = useState({});
  const [currentTabActiveKey, setCurrentTabActiveKey] = useState(null);
  const [tourGuideRun, setTourGuideRun] = useState(false);
  const [tourGuideSteps, setTourGuideSteps] = useState([]);
  const [tourStepIndex, setTourStepIndex] = useState(1);
  const [customFilterStatus, setCustomFilterStatus] = useState();

  // redux state
  const user = useSelector((state) => state?.user);
  const [customReportProducts, setCustomReportProducts] = useState([
    {
      label: 'Payment Gateway',
      key: 'pg_configuration',
      value: 'PG'
    },
    {
      label: 'Payment Link',
      key: 'ls_configuration',
      value: 'LS'
    },
    {
      label: 'Form & Feesbuzz',
      key: 'edu_configuration',
      value: 'EDU'
    }
  ]);
  const sampleCustomReportProductList = [
    {
      label: 'Payment Gateway',
      key: 'pg_configuration',
      value: 'PG'
    },
    {
      label: 'Payment Link',
      key: 'ls_configuration',
      value: 'LS'
    },
    {
      label: 'Form & Feesbuzz',
      key: 'edu_configuration',
      value: 'EDU'
    }
  ];
  const partnerId = user?.currentUser?._id;
  const permissions = useSelector((state) => state.user.planPermissions);
  const isCustomReportAllowed = useSelector(
    (state) => state.user.planPermissions.can_view_custom_report
  );
  const isGTVDashboardReportAllowed = useSelector(
    (state) => state.user.planPermissions.can_view_gtv_dashboard_report
  );
  const isInvoiceReportAllowed = useSelector(
    (state) => state.user.planPermissions.can_view_invoice_custom_report
  );
  const isCustomReportTransactionAllowed = useSelector(
    (state) => state.user.planPermissions.can_view_transaction_custom_report
  );
  const isCustomAccountReportAllowed = useSelector(
    (state) => state.user.planPermissions.can_view_wire_account_report
  );
  const isCustomTransferReportAllowed = useSelector(
    (state) => state.user.planPermissions.can_view_wire_transfer_report
  );
  const isCustomReportSettlementAllowed = useSelector(
    (state) => state.user.planPermissions.can_view_settlement_custom_report
  );
  const isCustomReportRefundAllowed = useSelector(
    (state) => state.user.planPermissions.can_view_refund_custom_report
  );
  const isCustomReportCommissionAllowed = useSelector(
    (state) => state.user.planPermissions.can_view_commission_custom_report
  );

  const isCustomReportInstacollectTransactionAllowed = useSelector(
    (state) => state.user.planPermissions.can_view_instacollect_transaction_report
  );
  const isCustomReportInstacollectSettlementAllowed = useSelector(
    (state) => state.user.planPermissions.can_view_instacollect_settlement_report
  );

  const tourGuide = useSelector((state) => state.user.navigationTourGuidetails);

  const isViewGTVtypeAllowed = [BITLA_ID, TESTING_ID].includes(partnerId);
  const isViewStateAllowed = [BITLA_ID, TESTING_ID].includes(partnerId);
  const zipAllowedType = ['COMMISSION', 'INVOICE'];
  // const planType = useSelector((state) => state.user.plan.plan_type);
  const planModal = useSelector((state) => state.user.planModal);
  // for the limit of 1 year for the particular partner gokwik
  const exemptPartnerId = [76676];
  const dispatch = useDispatch();

  const togglePlanModal = () => {
    dispatch(updatePlanModal(!planModal));
  };

  const handleTrackingService = (event, eventName) => {
    const trackingProperty = {};
    if (eventName === EVENT_NAME.DROPDOWN || eventName === EVENT_NAME.DATE_PICKER) {
      trackingProperty.selected_value = event?.value;
      trackingProperty.name = event?.name;
    } else {
      trackingProperty.name = event?.target?.name;
    }
    trackingService.trackEvent(eventName, trackingProperty);
  };

  const reportType = {
    ...(Object.prototype.hasOwnProperty.call(permissions, 'can_view_transaction_custom_report') && {
      TRANSACTION: {
        label: 'Transaction Report'
      }
    }),
    ...(Object.prototype.hasOwnProperty.call(permissions, 'can_view_settlement_custom_report') && {
      SETTLEMENT: {
        label: 'Settlement Report'
      }
    }),
    ...(Object.prototype.hasOwnProperty.call(permissions, 'can_view_refund_custom_report') && {
      REFUND: {
        label: 'Refund Report'
      }
    }),
    ...(Object.prototype.hasOwnProperty.call(permissions, 'can_view_commission_custom_report') && {
      COMMISSION: {
        label: 'Commission Report'
      }
    }),
    ...(Object.prototype.hasOwnProperty.call(permissions, 'can_view_invoice_custom_report') && {
      INVOICE: {
        label: 'Invoice Report'
      }
    }),
    ...(Object.prototype.hasOwnProperty.call(permissions, 'can_view_wire_account_report') && {
      ACCOUNT_REPORT: {
        label: 'Account Report'
      }
    }),
    ...(Object.prototype.hasOwnProperty.call(permissions, 'can_view_wire_transfer_report') && {
      TRANSFER_REPORT: {
        label: 'Transfer Report'
      }
    }),
    ...(Object.prototype.hasOwnProperty.call(
      permissions,
      'can_view_instacollect_transaction_report'
    ) && {
      INSTACOLLECT_TRANSACTION_REPORT: {
        label: 'Merchant Instacollect Transaction Report'
      }
    }),
    ...(Object.prototype.hasOwnProperty.call(
      permissions,
      'can_view_instacollect_settlement_report'
    ) && {
      INSTACOLLECT_SETTLEMENT_REPORT: {
        label: 'Merchant Instacollect Settlement Report'
      }
    })
  };

  // hooks
  const [merchantForm] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  //

  // Apis Function
  const fetchCustomReportsList = async (pagination, filters, type) => {
    setLoading(true);

    const response = await reportsAPI.customReportsList({
      current_page: pagination.current,
      total_counts: pagination.total,
      report_type: type,
      ...filters
    });

    if (!response.success) {
      console.log('something went wrong');
      // Alert('something went wrong', 'Please contact support team for this', 'error');
      setHasData(false);
    }

    setData(response?.data ?? []);
    setLoading(false);
    setTableParams({
      ...tableParams,
      pagination: {
        ...pagination,
        total: response?.data.total_counts
      }
    });
    setpendingCount(response?.data?.pending_total_counts);
  };
  //

  // Functions
  const handleViewMore = (e) => {
    setViewMoreModal(e);
    setCurrentView(null);
  };

  const handleViewDetails = (e) => {
    handleViewMore(true);
    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
      name: 'Custom-Report View Details'
    });
    const t = CUSTOM_REPORT_STATUS[e.status] ? (
      <Tag
        color={CUSTOM_REPORT_STATUS[e.status].bgColor}
        style={{
          padding: '2px 13px',
          color: CUSTOM_REPORT_STATUS[e.status].color,
          fontSize: '12px'
        }}
      >
        {e.status === 'SUCCESS' && <SuccessIcon style={{ fontSize: '10px' }} />}
        {e.status === 'INPROGRESS' && <InProgressIcon style={{ fontSize: '10px' }} />}
        {e.status === 'REQUESTED' && <InProgressIcon style={{ fontSize: '10px' }} />}
        {e.status === 'FAILED' && <FailedIcon style={{ fontSize: '10px' }} />}{' '}
        {CUSTOM_REPORT_STATUS[e.status].label}
      </Tag>
    ) : (
      <Tag color="#EBEBEB" style={{ padding: '2px 13px', color: '#7B7B7B', fontSize: '12px' }}>
        {e.status}
      </Tag>
    );

    const p = [];
    e.product_list.forEach((i) => {
      p.push(
        <Tag
          color="#e7defe"
          style={{ padding: '2px 13px', color: '#7263e6', fontSize: '12px', marginTop: '10px' }}
        >
          {PARTENR_PRODUCT_LIST[i]?.label}
        </Tag>
      );
    });

    const q = [];
    e.requested_status_list.forEach((i) => {
      if (CUSTOM_REPORT_TRANSACTION_STATUS[i]) {
        q.push(
          <Tag
            color={CUSTOM_REPORT_TRANSACTION_STATUS[i].bgColor}
            style={{
              padding: '2px 13px',
              color: CUSTOM_REPORT_TRANSACTION_STATUS[i].color,
              fontSize: '12px'
            }}
          >
            {CUSTOM_REPORT_TRANSACTION_STATUS[i].label}
          </Tag>
        );
      } else {
        q.push(
          <Tag color="#EBEBEB" style={{ padding: '2px 13px', color: '#7B7B7B', fontSize: '12px' }}>
            {i}
          </Tag>
        );
      }
    });

    const a = {
      format: {
        ...e,
        generation_date:
          e.generation_date === null
            ? 'Invalid Date'
            : dayjs(e.generation_date).format("DD MMM, 'YY"),
        start_date:
          e.start_date === null ? 'Invalid Date' : dayjs(e.start_date).format("DD MMM, 'YY"),
        end_date: e.end_date === null ? 'Invalid Date' : dayjs(e.end_date).format("DD MMM, 'YY"),
        status: t,
        ...(e.mapping.length > 0 && {
          merchant_count: e.mapping.length
        }),
        product_list_format: <div style={{ display: 'flex', flexWrap: 'wrap' }}>{p}</div>,
        ...(e.requested_status_list.length > 0 && {
          requested_status_list_format: q
        })
      },
      unformat: { ...e }
    };

    setCurrentView(a);
  };

  const handleCancel = () => {
    merchantForm.resetFields();
    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
      name: 'Generate New Report canceled'
    });
    setModalOpen(false);
  };

  const handleReportsModal = () => {
    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
      name: 'Generate New Report Click',
      'report-type': customReportType
    });
    merchantForm.setFieldsValue({
      status: customFilterStatus,
      products: customReportProducts
    });
    if (pendingCount >= 4) {
      message.info(
        `Hold on for a moment! Reports are currently running, and once they succeed, you can generate them. Thanks!`
      );
    } else {
      setModalOpen(true);
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter
    });

    fetchCustomReportsList(pagination, filtersObj, customReportType);
  };

  const onOpenChange = (open) => {
    if (open) {
      setDates([null, null]);
      merchantForm.setFieldsValue({
        Date: [null, null]
      });
    }
  };

  const isWithinLast6Months = (date) => {
    const sixMonthsAgo = dayjs().subtract(5, 'month');
    return date.isAfter(sixMonthsAgo) && date.isBefore(dayjs().add(0, 'day'));
  };
  const isWithinLastEighteenMonths = (date) => {
    const eighteenMonthsAgo = dayjs().subtract(59, 'month');
    return date.isAfter(eighteenMonthsAgo) && date.isBefore(dayjs().add(0, 'day'));
  };
  const disabledDate = (current) => {
    let dateDisable = '';
    if (dates && (dates[0] !== null || dates[1] !== null)) {
      if (!dates) {
        return false;
      }
      const datediff1 = dates[0] && current.diff(dates[0], 'days') >= 31;
      const datediff2 = dates[1] && dates[1].diff(current, 'days') >= 31;
      dateDisable = !!datediff1 || !!datediff2 || dayjs(current).isAfter(Date.now(), 'day');
    }
    if (exemptPartnerId.includes(user?.currentUser?._id)) {
      dateDisable = !isWithinLastEighteenMonths(current);
    } else {
      dateDisable = !isWithinLast6Months(current);
    }
    return dateDisable;
  };

  // Api's Function
  const fetchMerchantReportList = async () => {
    const response = await reportsAPI.merchant_list();

    const options = [];
    response.data.forEach((e) => {
      options.push({
        value: e.merchant_id,
        label: e.name,
        email: e.email
      });
    });

    setMerchant(options);
  };

  const fetchDownloadableReports = async (uniqueId, uniqueKey, fileName) => {
    const response = await reportsAPI.downloadReport({
      unique_id: uniqueId,
      unique_key: uniqueKey,
      ...(fileName && {
        file_name: fileName
      })
    });
    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
      name: 'Custom-Report Downloaded',
      'File-Name': fileName,
      'unique-id': uniqueId
    });
    if (response.success) {
      window.open(response.data.url);
    } else {
      Alert('Oops!!!', 'Something went wrong. Try again.', 'error');
    }
  };

  const generateCustomReports = async (v) => {
    handleCancel();
    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, { name: 'Generated Custom Report Click' });
    messageApi.open({
      type: 'loading',
      content: 'Generating report',
      duration: 0
    });
    let dateFormate = 'YYYY-MM-DD';
    if (v.report_type === 'INVOICE') dateFormate = 'YYYY-MM-01';

    setCustomReportType(v.report_type);
    setCurrentTabActiveKey(v.report_type);
    const response = await reportsAPI.generateCustomReports({
      report_type: v.report_type,
      report_name: v.report_name,
      merchant_id: v.merchants.map((e) => {
        return e.value;
      }),
      filter: {
        gtv_type: v?.gtv_type?.map((e) => {
          return e.value;
        }),
        state: v?.state?.map((e) => {
          return e.value;
        }),
        include_spilt: v?.include_spilt
      },
      product_list: v.products.map((e) => {
        return e.value;
      }),
      requested_status_list:
        v.status !== undefined
          ? v.status.map((e) => {
              return e.value;
            })
          : ['SUCCESS'],
      start_date: dayjs(v.Date[0]).format(dateFormate),
      end_date: dayjs(v.Date[1]).format(dateFormate)
    });
    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
      name: 'Report Generated',
      'report-type': v.report_type
    });
    if (response.success) {
      merchantForm.resetFields();
      setTimeout(messageApi.destroy, 2500);
      fetchCustomReportsList(tableParams.pagination, filtersObj, v.report_type);
    } else {
      setTimeout(messageApi.destroy, 100);
      Alert('Oops!!!', 'Something went wrong. Try again.', 'error');
    }
  };

  const applyFiltersCallbackfunc = (a) => {
    setLoading(true);

    const updatePagination = { ...tableParams.pagination };
    updatePagination.current = 1;
    updatePagination.total = 0;

    const [searchParams, checkboxGroup] = a;
    const filters = {
      ...searchParams,
      ...checkboxGroup
    };
    setFiltersObj(filters);
    fetchCustomReportsList(updatePagination, filters, customReportType);
  };

  const clearFiltersCallBackfun = () => {
    setLoading(true);

    const updatePagination = { ...tableParams.pagination };
    updatePagination.current = 1;
    updatePagination.total = 0;

    setFiltersObj({});
    fetchCustomReportsList(updatePagination, {}, customReportType);
  };

  const disabledMonthsDate = (current) => {
    if (!current) return false;

    const today = dayjs().startOf('month');

    return current.isSame(today, 'month') || current.isAfter(today, 'month');
  };

  const columns = [
    {
      title: <Space>Report ID</Space>,
      dataIndex: '_id',
      key: '_id',
      ellipsis: {
        showTitle: false
      }
    },
    {
      title: <Space>Report Name</Space>,
      dataIndex: 'report_name',
      key: 'report_name',
      ellipsis: {
        showTitle: false
      }
    },
    {
      title: <Space>Generation Date</Space>,
      dataIndex: 'generation_date',
      key: 'generation_date',
      ellipsis: {
        showTitle: false
      },
      render: (e) => {
        return e === null ? 'Invalid Date' : dayjs(e).format("DD MMM, 'YY");
      }
    },
    {
      title: <Space>Report Start Date</Space>,
      dataIndex: 'start_date',
      key: 'start_date',
      ellipsis: {
        showTitle: false
      },
      render: (e) => {
        return e === null ? 'Invalid Date' : dayjs(e).format("DD MMM, 'YY");
      }
    },
    {
      title: <Space>Report End Date</Space>,
      dataIndex: 'end_date',
      key: 'end_date',
      ellipsis: {
        showTitle: false
      },
      render: (e) => {
        return e === null ? 'Invalid Date' : dayjs(e).format("DD MMM, 'YY");
      }
    },
    {
      title: <Space>Status</Space>,
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      render: (e) => {
        const t = CUSTOM_REPORT_STATUS[e] ? (
          <Tag
            color={CUSTOM_REPORT_STATUS[e].bgColor}
            style={{
              padding: '2px 13px',
              color: CUSTOM_REPORT_STATUS[e].color,
              fontSize: '12px'
            }}
          >
            {e === 'SUCCESS' && <SuccessIcon style={{ fontSize: '10px' }} />}
            {e === 'INPROGRESS' && <InProgressIcon style={{ fontSize: '10px' }} />}
            {e === 'REQUESTED' && <InProgressIcon style={{ fontSize: '10px' }} />}
            {e === 'FAILED' && <FailedIcon style={{ fontSize: '10px' }} />}{' '}
            {CUSTOM_REPORT_STATUS[e].label}
          </Tag>
        ) : (
          <Tag color="#EBEBEB" style={{ padding: '2px 13px', color: '#7B7B7B', fontSize: '12px' }}>
            {e}
          </Tag>
        );
        return t;
      }
    },
    {
      title: <Space>Actions</Space>,
      align: 'center',
      render: (r) => {
        const t =
          r.status === 'SUCCESS' ? (
            <DownloadIcon
              style={{ fontSize: '15px', cursor: 'pointer' }}
              onClick={() => {
                fetchDownloadableReports(
                  r._id,
                  r.athena_s3_url,
                  zipAllowedType.includes(r.report_type)
                    ? `${r.report_name}.zip`
                    : `${r.report_name}.csv`
                );
              }}
            />
          ) : (
            <DownloadIcon style={{ fontSize: '15px', color: '#bbbbbf', cursor: 'not-allowed' }} />
          );

        return (
          // <Space size="middle">
          <div style={{ width: '50%', margin: 'auto' }}>
            <Row>
              <Col span={12}>
                <EyeFilled
                  style={{ color: '#989898', cursor: 'pointer', fontSize: '20px' }}
                  onClick={() => handleViewDetails(r)}
                />
              </Col>
              <Col span={12}>{t}</Col>
            </Row>
          </div>
          // </Space>
        );
      }
    }
  ];

  const handleTabChange = (e) => {
    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, { name: e });
    setCurrentTabActiveKey(e);
    setCustomReportType(e);
    setFiltersObj({});
    setTableParams({
      ...tableParams,
      pagination: {
        current: 1,
        total: 0
      }
    });

    fetchCustomReportsList({ ...tableParams.pagination, current: 1, total: 0 }, {}, e);
  };

  const tabMenu = [];
  const tabOptions = [];

  if (permissions?.can_view_transaction_custom_report) {
    tabMenu.push({
      key: 'TRANSACTION',
      label: `Merchant Transactions`,
      isAllowed: isCustomReportTransactionAllowed,
      filter: {
        filtersArr: [
          {
            label: 'Status',
            attr: 'status',
            data: customReportStatus
          },
          {
            label: 'Product',
            attr: 'product_list',
            data: customReportProducts
          },
          {
            label: 'Transactions Status',
            attr: 'requested_status_list',
            data: customReportTransactionsStatus
          }
        ],
        searchArr: [
          {
            label: 'Report ID',
            value: 'report_id'
          },
          {
            label: 'Report Name',
            value: 'report_name'
          }
        ]
      }
    });

    if (isCustomReportTransactionAllowed === true) {
      tabOptions.push({
        label: 'Transaction Report',
        value: 'TRANSACTION'
      });
    }
  }

  if (permissions?.can_view_settlement_custom_report) {
    tabMenu.push({
      key: 'SETTLEMENT',
      label: `Merchant Settlements`,
      isAllowed: isCustomReportSettlementAllowed,
      filter: {
        filtersArr: [
          {
            label: 'Status',
            attr: 'status',
            data: customReportStatus
          },
          {
            label: 'Product',
            attr: 'product_list',
            data: customReportProducts
          }
        ],
        searchArr: [
          {
            label: 'Report ID',
            value: 'report_id'
          },
          {
            label: 'Report Name',
            value: 'report_name'
          }
        ]
      }
    });

    if (isCustomReportSettlementAllowed === true) {
      tabOptions.push({
        label: 'Settlement Report',
        value: 'SETTLEMENT'
      });
    }
  }

  if (permissions?.can_view_refund_custom_report) {
    tabMenu.push({
      key: 'REFUND',
      label: `Merchant Refunds`,
      isAllowed: isCustomReportRefundAllowed,
      filter: {
        filtersArr: [
          // {
          //   label: 'Activation status',
          //   attr: 'activation_status',
          //   data: activationStatus
          // },
          {
            label: 'Status',
            attr: 'status',
            data: customReportStatus
          },
          {
            label: 'Product',
            attr: 'product_list',
            data: customReportProducts
          }
        ],
        searchArr: [
          {
            label: 'Report ID',
            value: 'report_id'
          },
          {
            label: 'Report Name',
            value: 'report_name'
          }
        ]
      }
    });

    if (isCustomReportRefundAllowed === true) {
      tabOptions.push({
        label: 'Refund Report',
        value: 'REFUND'
      });
    }
  }

  if (permissions?.can_view_commission_custom_report) {
    tabMenu.push({
      key: 'COMMISSION',
      label: `Partner Commissions`,
      isAllowed: isCustomReportCommissionAllowed,
      filter: {
        filtersArr: [
          // {
          //   label: 'Activation status',
          //   attr: 'activation_status',
          //   data: activationStatus
          // },
          {
            label: 'Status',
            attr: 'status',
            data: customReportStatus
          },
          {
            label: 'Product',
            attr: 'product_list',
            data: customReportProducts
          }
        ],
        searchArr: [
          {
            label: 'Report ID',
            value: 'report_id'
          },
          {
            label: 'Report Name',
            value: 'report_name'
          }
        ]
      }
    });

    if (isCustomReportCommissionAllowed === true) {
      tabOptions.push({
        label: 'Commission Report',
        value: 'COMMISSION'
      });
    }
  }
  if (permissions?.can_view_invoice_custom_report) {
    tabMenu.push({
      key: 'INVOICE',
      label: `Merchant Invoice`,
      isAllowed: isInvoiceReportAllowed,
      filter: {
        filtersArr: [
          {
            label: 'Status',
            attr: 'status',
            data: customReportStatus
          },
          {
            label: 'Product',
            attr: 'product_list',
            data: customReportProducts
          }
        ],
        searchArr: [
          {
            label: 'Report ID',
            value: 'report_id'
          },
          {
            label: 'Report Name',
            value: 'report_name'
          }
        ]
      }
    });

    if (isInvoiceReportAllowed === true) {
      tabOptions.push({
        label: 'Invoice Report',
        value: 'INVOICE'
      });
    }
  }
  if (permissions?.can_view_wire_account_report) {
    tabMenu.push({
      key: 'ACCOUNT_REPORT',
      label: `Merchant Account Statement`,
      isAllowed: isCustomAccountReportAllowed,
      filter: {
        filtersArr: [
          {
            label: 'Status',
            attr: 'status',
            data: customReportStatus
          },
          {
            label: 'Product',
            attr: 'product_list',
            data: [
              {
                label: 'Wire',
                value: 'WIRE'
              }
            ]
          }
        ],
        searchArr: [
          {
            label: 'Report ID',
            value: 'report_id'
          },
          {
            label: 'Report Name',
            value: 'report_name'
          }
        ]
      }
    });

    if (isCustomAccountReportAllowed === true) {
      tabOptions.push({
        label: 'Account Statement Report',
        value: 'ACCOUNT_REPORT'
      });
    }
  }
  if (permissions?.can_view_wire_transfer_report) {
    tabMenu.push({
      key: 'TRANSFER_REPORT',
      label: `Merchant Transfer Report`,
      isAllowed: isCustomTransferReportAllowed,
      filter: {
        filtersArr: [
          {
            label: 'Status',
            attr: 'status',
            data: customReportStatus
          },
          {
            label: 'Product',
            attr: 'product_list',
            data: [
              {
                label: 'Wire',
                value: 'WIRE'
              }
            ]
          }
        ],
        searchArr: [
          {
            label: 'Report ID',
            value: 'report_id'
          },
          {
            label: 'Report Name',
            value: 'report_name'
          }
        ]
      }
    });

    if (isCustomTransferReportAllowed === true) {
      tabOptions.push({
        label: 'Transfer Report',
        value: 'TRANSFER_REPORT'
      });
    }
  }
  if (permissions?.can_view_instacollect_transaction_report) {
    tabMenu.push({
      key: 'INSTACOLLECT_TRANSACTION_REPORT',
      label: `Merchant Instacollect Transaction Report`,
      isAllowed: isCustomReportInstacollectTransactionAllowed,
      filter: {
        filtersArr: [
          {
            label: 'Status',
            attr: 'status',
            data: customReportStatus
          },
          {
            label: 'Product',
            attr: 'product_list',
            data: [
              {
                label: 'Instacollect',
                value: 'INSTACOLLECT'
              }
            ]
          }
        ],
        searchArr: [
          {
            label: 'Report ID',
            value: 'report_id'
          },
          {
            label: 'Report Name',
            value: 'report_name'
          }
        ]
      }
    });

    if (isCustomReportInstacollectTransactionAllowed === true) {
      tabOptions.push({
        label: 'Merchant Instacollect Transaction Report',
        value: 'INSTACOLLECT_TRANSACTION_REPORT'
      });
    }
  }
  if (permissions?.can_view_instacollect_settlement_report) {
    tabMenu.push({
      key: 'INSTACOLLECT_SETTLEMENT_REPORT',
      label: `Merchant Instacollect Settlement Report`,
      isAllowed: isCustomReportInstacollectSettlementAllowed,
      filter: {
        filtersArr: [
          {
            label: 'Status',
            attr: 'status',
            data: customReportStatus
          },
          {
            label: 'Product',
            attr: 'product_list',
            data: [
              {
                label: 'Instacollect',
                value: 'INSTACOLLECT'
              }
            ]
          }
        ],
        searchArr: [
          {
            label: 'Report ID',
            value: 'report_id'
          },
          {
            label: 'Report Name',
            value: 'report_name'
          }
        ]
      }
    });

    if (isCustomReportInstacollectSettlementAllowed === true) {
      tabOptions.push({
        label: 'Merchant Instacollect Settlement Report',
        value: 'INSTACOLLECT_SETTLEMENT_REPORT'
      });
    }
  }

  const fetchAndUpdateNavigation = async (paramKey) => {
    const request = {
      update: paramKey
    };
    const response = await merchantAPI.fetchNavigationFlag(request);
    if (response.success) {
      dispatch(updateNavigationTourGuide(response?.data));
    } else {
      console.log('something went wrong');
    }
  };

  const handleJoyrideCallback = (callbackProps) => {
    const { status, index, action, step, type, size } = callbackProps;

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Need to set our running state to false, so we can restart if we click start again.
      setTourGuideRun(false);
    } else if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      if ([ACTIONS.NEXT].includes(action)) {
        const nextIndex = index + 1;
        setTourStepIndex(nextIndex);
      } else {
        const prevIndex = index - 1;
        setTourStepIndex(prevIndex);
      }

      if (index === 1 && [ACTIONS.PREV].includes(action)) {
        setTourGuideRun(false);
        fetchAndUpdateNavigation('disable_custom_report_guide');
      }
    }
    const lastStepIndex = size - index;
    if ([ACTIONS.CLOSE].includes(action) || [EVENTS.TOUR_END].includes(type)) {
      if (lastStepIndex > 1) {
        setTourStepIndex(size - 1);
      } else {
        setTourGuideRun(false);
        fetchAndUpdateNavigation('disable_custom_report_guide');
      }
    }
  };
  const handleTreeSelecter = (status) => {
    if (status === 'TRANSFER_REPORT') {
      setCustomFilterStatus(CUSTOM_REPORT_TRANSFER_STATUS);
      merchantForm.setFieldsValue({
        status: CUSTOM_REPORT_TRANSFER_STATUS
      });
    } else if (status === 'TRANSACTION') {
      setCustomFilterStatus([
        {
          label: 'Success',
          value: 'SUCCESS'
        },
        {
          label: 'Failed',
          value: 'FAILED'
        },
        {
          label: 'Bounced',
          value: 'BOUNCED'
        },
        {
          label: 'Dropped',
          value: 'DROPPED'
        }
      ]);
      merchantForm.setFieldsValue({
        status: [
          {
            label: 'Success',
            value: 'SUCCESS'
          },
          {
            label: 'Failed',
            value: 'FAILED'
          },
          {
            label: 'Bounced',
            value: 'BOUNCED'
          },
          {
            label: 'Dropped',
            value: 'DROPPED'
          }
        ]
      });
    }
    if (status === 'ACCOUNT_REPORT' || status === 'TRANSFER_REPORT') {
      setCustomReportProducts([{ label: 'Wire', value: 'WIRE', key: 'wire_configuration' }]);
      merchantForm.setFieldsValue({
        products: [{ label: 'Wire', value: 'WIRE', key: 'wire_configuration' }]
      });
    } else if (status === 'COMMISSION') {
      setCustomReportProducts([
        ...sampleCustomReportProductList,
        { label: 'Wire', value: 'WIRE', key: 'wire_configuration' },
        { label: 'Instacollect', value: 'INSTACOLLECT', key: 'instacollect_configuration' }
      ]);
      merchantForm.setFieldsValue({
        products: [
          ...sampleCustomReportProductList,
          { label: 'Wire', value: 'WIRE', key: 'wire_configuration' }
        ]
      });
    } else if (status === 'INSTACOLLECT_TRANSACTION_REPORT') {
      setCustomReportProducts([
        { label: 'Instacollect', value: 'INSTACOLLECT', key: 'instacollect_configuration' }
      ]);
      merchantForm.setFieldsValue({
        products: [
          { label: 'Instacollect', value: 'INSTACOLLECT', key: 'instacollect_configuration' }
        ]
      });
      setCustomFilterStatus(CUSTOM_REPORT_INSTACOLLECT_TRANSACTION_STATUS);
      merchantForm.setFieldsValue({
        status: CUSTOM_REPORT_INSTACOLLECT_TRANSACTION_STATUS
      });
    } else if (status === 'INSTACOLLECT_SETTLEMENT_REPORT') {
      setCustomReportProducts([
        { label: 'Instacollect', value: 'INSTACOLLECT', key: 'instacollect_configuration' }
      ]);
      merchantForm.setFieldsValue({
        products: [
          { label: 'Instacollect', value: 'INSTACOLLECT', key: 'instacollect_configuration' }
        ]
      });
    } else {
      setCustomReportProducts(sampleCustomReportProductList);
      merchantForm.setFieldsValue({ products: sampleCustomReportProductList });
    }
  };

  // Effects
  useEffect(() => {
    if (isCustomReportAllowed) {
      setLoading(true);
      fetchMerchantReportList();
      if (tabMenu.length > 0) {
        trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, { name: tabMenu[0].key });
        fetchCustomReportsList(tableParams.pagination, filtersObj, tabMenu[0].key);
        setCustomReportType(tabMenu[0].key);
      }
    } else {
      navigate('/referrals');
    }
  }, []);

  useEffect(() => {
    if (isCustomReportAllowed && tourGuide) {
      setLoading(true);
      fetchMerchantReportList();
      if (tabMenu.length > 0) {
        fetchCustomReportsList(tableParams.pagination, filtersObj, tabMenu[0].key);
        setCustomReportType(tabMenu[0].key);
        if (
          tourGuide?.dashboard_guide?.tour_guide &&
          tourGuide?.dashboard_guide?.dashboard_modules?.disable_custom_report_guide
        ) {
          setTourGuideRun(!tourGuideRun);
          setTourGuideSteps(TOUR_CUSTOM_REPORT_CONTENT);
        }
      }
    }
  }, [isCustomReportAllowed, tourGuide]);
  useEffect(() => {
    handleTreeSelecter(customReportType);
  }, [customReportType]);

  useEffect(() => {
    if (Object.keys(data).length !== 0) {
      setHasData(true);
    }
  }, [data]);

  useEffect(() => {
    if (modalOpen)
      merchantForm.setFieldsValue({
        report_type: customReportType
      });
  }, [modalOpen]);

  // <Result
  //   icon={<InfoCircleFilled style={{ color: ''var(--color-primary)'' }} />}
  //   title="No Data Found"
  //   subTitle="Sorry, No Data Found"
  // />

  return (
    <div
      style={{
        padding: '10px 24px'
      }}
    >
      <Joyride
        callback={handleJoyrideCallback}
        continuous
        run={tourGuideRun}
        steps={tourGuideSteps}
        scrollOffset={64}
        showSkipButton
        styles={{
          options: {
            primaryColor: 'var(--color-fill-alter)',
            zIndex: 100
          }
        }}
        tooltipComponent={joyrideCustomTooltip}
        stepIndex={tourStepIndex}
      />
      <div style={{ marginTop: '25px' }}>
        {tabMenu.length > 0 && (
          <Tabs
            {...(currentTabActiveKey !== null && { activeKey: currentTabActiveKey })}
            size="large"
            items={tabMenu.map((tab) => {
              return {
                label: `${tab.label}`,
                key: `${tab.key}`,
                children: (
                  <>
                    <Space
                      direction="horizontal"
                      style={{
                        width: '100%',
                        paddingBottom: '10px',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Space>
                        {tab.isAllowed && isCustomReportAllowed ? (
                          <EbzPopover
                            placement="bottomLeft"
                            content={
                              <EbzFilterGroup
                                searchParams={tab.filter.searchArr}
                                filters={tab.filter.filtersArr}
                                apply={applyFiltersCallbackfunc}
                                clear={clearFiltersCallBackfun}
                              />
                            }
                            trigger="click"
                            overlayStyle={{
                              width: '400px'
                            }}
                            overlayClassName="ebz-filters-popover"
                          >
                            <EbzButton size="large">
                              Search & Filter <DownOutlined />
                            </EbzButton>
                          </EbzPopover>
                        ) : (
                          <Button type="primary" size="large" disabled>
                            Search & Filter <DownOutlined />
                          </Button>
                        )}
                      </Space>
                      {!isCustomReportAllowed ? (
                        <Space size={10} className="generate-custom-report">
                          <Button type="primary" size="large" onClick={togglePlanModal}>
                            Generate New Report
                          </Button>
                        </Space>
                      ) : (
                        <Space size={10} className="generate-custom-report">
                          {!tab.isAllowed ? (
                            <Button type="primary" size="large" onClick={togglePlanModal}>
                              Generate New Report
                            </Button>
                          ) : !loading ? (
                            <Button type="primary" onClick={handleReportsModal} size="large">
                              Generate New Report
                            </Button>
                          ) : (
                            <Button type="primary" size="large" disabled>
                              Generate New Report
                            </Button>
                          )}
                        </Space>
                      )}
                    </Space>
                    {tab.isAllowed && isCustomReportAllowed ? (
                      <EbzTable
                        columns={columns}
                        rowKey={(r) => `${r._id}_reports`}
                        dataSource={hasData ? data.custom_reports : []}
                        loading={loading}
                        pagination={tableParams.pagination}
                        onChange={handleTableChange}
                        size="middle"
                      />
                    ) : (
                      <div
                        style={{
                          position: 'relative'
                        }}
                      >
                        <img
                          src={customReportTableBlur}
                          alt="CUstom Report Table"
                          style={{ maxWidth: '100%' }}
                        />
                        <div
                          style={{
                            position: 'absolute',
                            textAlign: 'center',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)'
                          }}
                        >
                          <Typography.Title level={4}>
                            Explore trends and search through reports on the dashboard. To generate
                            a new report, connect with your RM.
                          </Typography.Title>
                          <Button type="primary" onClick={togglePlanModal}>
                            View Plans
                          </Button>
                        </div>
                      </div>
                    )}
                  </>
                )
              };
            })}
            renderTabBar={renderTabBarMenu}
            onChange={handleTabChange}
          />
        )}
      </div>
      <Drawer
        title={
          <>
            <CloseIcon
              style={{
                fontSize: '30px',
                color: 'var(--color-primary)',
                position: 'absolute',
                top: '30px',
                left: '-16px',
                cursor: 'pointer'
              }}
              onClick={() => handleViewMore(false)}
            />
            <Typography.Text style={{ fontSize: '22px', fontWeight: '500' }}>
              View Report Details
            </Typography.Text>
          </>
        }
        placement="right"
        width={550}
        closable={false}
        open={viewMoreModal}
        rootClassName="payout-drawer"
      >
        <Row gutter={[20, 20]}>
          <Col span={24}>
            <Space
              direction="horizontal"
              style={{ width: '100%', justifyContent: 'space-between' }}
            >
              <Typography.Text>
                Report ID -
                <Typography.Text
                  copyable={{
                    icon: [
                      <CopyIcon style={{ color: 'var(--color-primary)' }} />,
                      <CheckOutlined style={{ color: 'var(--color-primary)' }} />
                    ]
                  }}
                >
                  {currentView?.format?._id}
                </Typography.Text>
              </Typography.Text>
            </Space>
          </Col>
          <Col span={24}>
            <Descriptions column={1} bordered labelStyle={{ backgroundColor: '#FFFFFF' }}>
              <Descriptions.Item label="Report Name">
                {currentView?.format?.report_name}
              </Descriptions.Item>
              <Descriptions.Item label="Report Start Date">
                {currentView?.format?.start_date}
              </Descriptions.Item>
              <Descriptions.Item label="Report End Date">
                {currentView?.format?.end_date}
              </Descriptions.Item>
              <Descriptions.Item label="Generation Date">
                {currentView?.format?.generation_date}
              </Descriptions.Item>
              <Descriptions.Item label="Report Category">
                {currentView?.format?.report_type &&
                  reportType[currentView?.format?.report_type].label}
              </Descriptions.Item>
              <Descriptions.Item label="Status">{currentView?.format?.status}</Descriptions.Item>
              <Descriptions.Item label="Products">
                <span style={{ backgroundColor: 'red !important' }}>
                  {currentView?.format?.product_list_format}
                </span>
              </Descriptions.Item>
              {currentView?.format?.requested_status_list_format &&
                customReportType === 'TRANSFER_REPORT' && (
                  <Descriptions.Item label="Transfer Status">
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 8px' }}>
                      {currentView?.format?.requested_status_list_format}
                    </div>
                  </Descriptions.Item>
                )}
              {currentView?.format?.requested_status_list_format &&
                customReportType === 'TRANSACTION' && (
                  <Descriptions.Item label="Transactions Status">
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 8px' }}>
                      {currentView?.format?.requested_status_list_format}
                    </div>
                  </Descriptions.Item>
                )}
              {currentView?.format?.requested_status_list_format &&
                customReportType === 'INSTACOLLECT_TRANSACTION_REPORT' && (
                  <Descriptions.Item label="Transactions Status">
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 8px' }}>
                      {currentView?.format?.requested_status_list_format}
                    </div>
                  </Descriptions.Item>
                )}
              <Descriptions.Item
                label={<>Merchants [{currentView?.format?.merchant_count}]</>}
                labelStyle={{
                  verticalAlign: 'top'
                }}
              >
                <CustomScrollWrapper
                  style={{ width: '100%', maxHeight: '400px', overflow: 'auto' }}
                >
                  {currentView?.unformat?.mapping.map((i) => {
                    return <Typography>{i}</Typography>;
                  })}
                </CustomScrollWrapper>
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>
      </Drawer>
      {/* common modal for all tabs  */}
      <Modal
        title={
          <Typography.Text style={{ fontSize: '18px', fontWeight: '500' }}>
            Generate New Report
          </Typography.Text>
        }
        centered
        open={modalOpen}
        closable={false}
        onCancel={handleCancel}
        footer={[
          <Button onClick={handleCancel}>Cancel</Button>,
          <Button form="generate-report" key="submit" htmlType="submit" type="primary">
            Generate
          </Button>
        ]}
        style={{
          padding: '12px 25px'
        }}
        size="large"
      >
        <Form
          form={merchantForm}
          name="generate-report"
          layout="vertical"
          onFinish={generateCustomReports}
        >
          <Row gutter={[10, 8]}>
            <Col span={12}>
              <Form.Item
                name="report_type"
                label={
                  <>
                    <span>Category</span>
                    <span className="required-mark" />
                  </>
                }
                rules={[
                  {
                    required: true,
                    message: 'Please select category'
                  }
                ]}
              >
                <Select
                  suffixIcon={<CaretDownOutlined style={{ fontSize: '15px', color: '#2A2A2A' }} />}
                  style={{
                    width: '100%'
                  }}
                  placeholder="Please select category"
                  options={tabOptions}
                  size="middle"
                  onChange={(e) => {
                    handleTrackingService({ name: 'Category', value: e }, EVENT_NAME.DROPDOWN);
                    setCustomReportType(e);
                    handleTreeSelecter(e);
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="report_name"
                label={
                  <>
                    <span>Report Name</span>
                    <span className="required-mark" />
                    <Tooltip title="Only alphabet allowed">
                      <InfoCircleOutlined style={{ color: '#A0A0A0', marginLeft: '4px' }} />
                    </Tooltip>
                  </>
                }
                rules={[
                  {
                    validator(_, value) {
                      if (!value || value.trim().length === 0) {
                        return Promise.reject(new Error('Please enter report name'));
                      }

                      const pattern = /^[a-zA-Z][\w\- ]*$/;
                      if (!pattern.test(value)) {
                        return Promise.reject(new Error('Please enter a valid report name.'));
                      }

                      return Promise.resolve();
                    }
                  }
                ]}
              >
                <Input
                  name="report_name"
                  onClick={(e) => handleTrackingService(e, EVENT_NAME.TEXT_INPUT)}
                  style={{
                    width: '100%'
                  }}
                  placeholder="Please enter report name"
                  size="middle"
                />
              </Form.Item>
            </Col>
            {/* <Col span={24}> </Col> */}

            {(customReportType === 'TRANSACTION' ||
              customReportType === 'TRANSFER_REPORT' ||
              customReportType === 'INSTACOLLECT_TRANSACTION_REPORT') && (
              <Col span={12}>
                <Form.Item
                  name="status"
                  label={
                    <>
                      <span>Status</span>
                      <span className="required-mark" />
                    </>
                  }
                  rules={[
                    {
                      required: true,
                      message: 'Please select status'
                    }
                  ]}
                >
                  <EbzTreeSelect1
                    onChange={(selected) => {
                      handleTrackingService(
                        {
                          name: 'status',
                          value: selected.map(({ label }) => label)
                        },
                        EVENT_NAME.DROPDOWN
                      );
                    }}
                    data={customFilterStatus}
                  />
                </Form.Item>
              </Col>
            )}

            {customReportType === 'TRANSACTION' ||
            customReportType === 'TRANSFER_REPORT' ||
            customReportType === 'INSTACOLLECT_TRANSACTION_REPORT' ||
            customReportType === 'SETTLEMENT' ? (
              <Col span={customReportType === 'SETTLEMENT' ? 15 : 12}>
                <Form.Item
                  name="products"
                  label={
                    <>
                      <span>Products</span>
                      <span className="required-mark" />
                    </>
                  }
                  rules={[
                    {
                      required: true,
                      message: 'Please select products'
                    }
                  ]}
                >
                  <EbzTreeSelect1
                    onChange={(selected) => {
                      handleTrackingService(
                        {
                          name: 'products',
                          value: selected.map(({ label }) => label)
                        },
                        EVENT_NAME.DROPDOWN
                      );
                    }}
                    data={customReportProducts}
                  />
                </Form.Item>
              </Col>
            ) : (
              <Col span={24}>
                <Form.Item
                  name="products"
                  label={
                    <>
                      <span>Products</span>
                      <span className="required-mark" />
                    </>
                  }
                  rules={[
                    {
                      required: true,
                      message: 'Please select products'
                    }
                  ]}
                >
                  <EbzTreeSelect1
                    onChange={(selected) => {
                      handleTrackingService(
                        {
                          name: 'products',
                          value: selected.map(({ label }) => label)
                        },
                        EVENT_NAME.DROPDOWN
                      );
                    }}
                    data={customReportProducts}
                  />
                </Form.Item>
              </Col>
            )}
            {customReportType === 'SETTLEMENT' && (
              <Col span={9} style={{ paddingTop: '40px' }}>
                <Form.Item name="include_spilt" valuePropName="checked">
                  <Checkbox
                    onChange={(e) => {
                      handleTrackingService(
                        {
                          name: 'include_spilt_settlement',
                          value: e.target.checked
                        },
                        EVENT_NAME.CHECKBOX
                      );
                    }}
                  >
                    <Tooltip title="Include Split Settlements.">
                      <span>Split Settlements</span>
                    </Tooltip>
                  </Checkbox>
                </Form.Item>
              </Col>
            )}
            <Col span={24}>
              <Form.Item
                name="merchants"
                label={
                  <>
                    <span>Merchants</span>
                    <span className="required-mark" />
                  </>
                }
                rules={[
                  {
                    required: true,
                    message: 'Please select merchants'
                  }
                ]}
              >
                <EbzTreeSelect
                  onChange={(e) =>
                    handleTrackingService({ name: 'merchants' }, EVENT_NAME.DROPDOWN)
                  }
                  merchant={merchant}
                />
              </Form.Item>
            </Col>

            {customReportType === 'TRANSACTION' &&
              isGTVDashboardReportAllowed &&
              isViewGTVtypeAllowed && (
                <Col span={24}>
                  <Form.Item name="gtv_type" label={<span>GTV Type</span>}>
                    <EbzTreeSelect1
                      onChange={(selected) => {
                        handleTrackingService(
                          {
                            name: 'gtv_type',
                            value: selected.map(({ label }) => label)
                          },
                          EVENT_NAME.DROPDOWN
                        );
                      }}
                      placeHolder="Please Select GTV Type"
                      data={GTV_TYPE}
                      shouldSelectAll={false}
                    />
                  </Form.Item>
                </Col>
              )}
            {customReportType === 'TRANSACTION' &&
              isGTVDashboardReportAllowed &&
              isViewStateAllowed && (
                <Col span={24}>
                  <Form.Item name="state" label={<span>State</span>}>
                    <EbzTreeSelect1
                      onChange={(selected) => {
                        handleTrackingService(
                          {
                            name: 'state',
                            value: selected.map(({ label }) => label)
                          },
                          EVENT_NAME.DROPDOWN
                        );
                      }}
                      placeHolder="Please Select State"
                      data={STATES}
                    />
                  </Form.Item>
                </Col>
              )}
          </Row>

          {customReportType === 'INVOICE' ? (
            <Col span={24}>
              <Form.Item
                name="Date"
                label={
                  <>
                    {customReportType === 'INVOICE' && <span>Invoice Month</span>}
                    <span className="required-mark" />
                  </>
                }
                rules={[
                  {
                    required: true,
                    message: 'Please Select Invoice Month'
                  },
                  {
                    validator: (_, value) => {
                      if (value && value.length === 2) {
                        const [start, end] = value;
                        if (end.diff(start, 'months') > 3) {
                          return Promise.reject(
                            new Error('The selected range cannot exceed 4 months')
                          );
                        }
                      }
                      return Promise.resolve();
                    }
                  }
                ]}
              >
                <RangePicker
                  onChange={(value) => {
                    handleTrackingService(
                      { name: 'Date', value: value?.format('YYYY-MM-DD') },
                      EVENT_NAME.DATE_PICKER
                    );
                  }}
                  style={{
                    width: '100%'
                  }}
                  disabledDate={disabledMonthsDate}
                  picker="month"
                />
              </Form.Item>
            </Col>
          ) : (
            <Col span={24}>
              <Form.Item
                name="Date"
                label={
                  <>
                    {customReportType === 'TRANSACTION' && <span>Transaction Date</span>}
                    {customReportType === 'SETTLEMENT' && <span>Settlement Date</span>}
                    {customReportType === 'REFUND' && <span>Refund Raise Date</span>}
                    {customReportType === 'COMMISSION' && <span>Transaction Date</span>}
                    {customReportType === 'ACCOUNT_REPORT' && <span>Date Range</span>}
                    {customReportType === 'TRANSFER_REPORT' && <span>Date Range</span>}
                    {customReportType === 'INSTACOLLECT_TRANSACTION_REPORT' && (
                      <span>Instacollect Transaction Date Range</span>
                    )}
                    {customReportType === 'INSTACOLLECT_SETTLEMENT_REPORT' && (
                      <span>Instacollect Settlement Date Range</span>
                    )}
                    {customReportType === null && <span>Date</span>}
                    <span className="required-mark" />
                    {customReportType === 'SETTLEMENT' && (
                      <Tooltip title="This filters the transactions for which the settlement date is as per the below values">
                        <InfoCircleOutlined style={{ color: '#A0A0A0', marginLeft: '5px' }} />
                      </Tooltip>
                    )}
                  </>
                }
                rules={[
                  {
                    required: true,
                    message: 'Please select date range'
                  },
                  {
                    validator(_, value) {
                      if (value === null) {
                        return Promise.resolve();
                      }
                      if (value && value[0] === null && value[1] === null) {
                        // eslint-disable-next-line prefer-promise-reject-errors
                        return Promise.reject('Please enter valid Date');
                      }
                      if (
                        value &&
                        customReportType.length > 0 &&
                        value[1].diff(value[0], 'days') >= 31
                      ) {
                        // eslint-disable-next-line prefer-promise-reject-errors
                        return Promise.reject('Please Select Max Up to One Month ');
                      }
                      return Promise.resolve();
                    }
                  }
                ]}
              >
                <RangePicker
                  fallowClear
                  onCalendarChange={(val) => {
                    // handleTrackingService(
                    //   { name: 'Date', value: val?.format('YYYY-MM-DD') },
                    //   EVENT_NAME.DATE_PICKER
                    // );
                    setDates(val);
                  }}
                  format="YYYY-MM-DD"
                  style={{
                    width: '100%'
                  }}
                  size="middle"
                  disabledDate={disabledDate}
                  onOpenChange={onOpenChange}
                />
              </Form.Item>
            </Col>
          )}
        </Form>
      </Modal>
      {contextHolder}
    </div>
  );
}

export default CustomReportsListPage;
